import {BitrixVue} from 'ui.vue3';
import { mapState } from 'ui.vue3.pinia';
import { vplSiteStore } from 'vpl.tas';
import { num_word } from 'vpl.tas';

import { CatalogInnerSections } from 'vpl.tas.listing';
import { CatalogItems } from 'vpl.tas.listing';
import { SmartFilter } from 'vpl.tas.listing';



export const SearchSectionPage = {
    components: {
        SmartFilter,
        CatalogItems
    },
    props: {
        structKey: [String, Number]
    },
    methods: {

    },
    updated(){

    },
    mounted(){
        $('.js-search-tabs').click(function(e){
            e.preventDefault();
            $('.js-search-tabs').removeClass('is-active');
            $(this).addClass('is-active');
            $('.js-search-tab').hide();
            $(`.js-search-tab[data-tab=${$(this).data('tab-active')}]`).show();
        })
    },
    computed: {
        ...mapState(vplSiteStore, ['struct', 'SITE_TEMPLATE_PATH'])
    },
    /*
    <section class="section search-page__result">
        <div class="container">
            <div class="catalog__bottom js-catalog-wp">
                <SmartFilter :structKey="this.structKey" />
    */
    template: `
<section class="section js-search-tab" data-tab="products">
    <div class="container">
        <div class=" js-catalog-wp">

            <CatalogItems :structKey="this.structKey" />
        </div>
    </div>
</section>
`
}